import { doc, getDoc } from "firebase/firestore";
import { db } from "../firebase";

export const getCommunityByCommunityCode = (communityCode) => {
  return getDoc(doc(db, "community", communityCode)).then((docSnap) => {
    return docSnap.data();
  });
};
